import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import SlicesWrapper from 'components/slices';
import { changeDomain } from 'components/richText/changeDomain';
import RelatedBlogArticles from 'components/richText/blogs/RelatedArticles'

import RenderRichText from 'utils/richText/renderRichText';
import createAnchorLinks from 'utils/functions/createAnchorLinks';

import {StyledBlogSmallHeading} from 'components/blog/styled';

const isFR = process.env.LANG_CODE === 'fr-fr';

const RichPost = ({ 
  richContent, 
  slices, 
  preview, 
  documentId, 
  language, 
  isBlog, 
  blogAritclePhoneNumber, 
  relatedBlogArticles,
  readMoreText,
  pageContext,
  datePublished,
  isAircraftTemplate
}) => {
  useEffect(() => {
    changeDomain()
    createAnchorLinks();
  }, [])

  const relatedBlogArticlesArray = isBlog && relatedBlogArticles.filter(el => el.id !== pageContext.id).sort((a, b) => {
    const dateA = a.data.date_published
    const dateB = b.data.date_published

    return new Date(dateB) - new Date(dateA)
  })

  const dateOptions = { day: '2-digit', month: 'long', year: 'numeric' };
  const datePublishedFormatted = new Date(datePublished).toLocaleDateString(isFR ? "fr-fr" : "en-gb", dateOptions).split(' ');
  const articleDatePublished = `${datePublishedFormatted[0]} ${datePublishedFormatted[1]} ${datePublishedFormatted[2]}`;

  return (
    <article data-wio-id={documentId}>

      {isBlog && (
        <div style={{marginBottom: '10px', fontSize: '15px'}}>
          <StyledBlogSmallHeading> {articleDatePublished} </StyledBlogSmallHeading>
        </div>
      )}

      {richContent != null ? 
        <RenderRichText 
          richTextArray={richContent} 
          language={language}
          blogAritclePhoneNumber={blogAritclePhoneNumber}
        />
      : null}
      
      <SlicesWrapper 
        slices={slices} 
        preview={preview}
        language={language}
        isAircraftTemplate={isAircraftTemplate}
        blogAritclePhoneNumber={blogAritclePhoneNumber} 
      />

      { isBlog && relatedBlogArticlesArray.length > 0 && (
        <RelatedBlogArticles
          relatedBlogArticlesArray={relatedBlogArticlesArray}
          readMoreText={readMoreText}
          isFR={isFR}
        />
      )}

    </article>
  );
}

export default RichPost;

RichPost.propTypes = {
  blogAritclePhoneNumber: PropTypes.string,
  datePublished: PropTypes.string,
  documentId: PropTypes.string,
  isAircraftTemplate: PropTypes.bool,
  isBlog: PropTypes.bool,
  language: PropTypes.string,
  pageContext: PropTypes.object,
  preview: PropTypes.bool,
  readMoreText: PropTypes.string,
  relatedBlogArticles: PropTypes.array,
  richContent: PropTypes.array,
  slices: PropTypes.array
};